import type { CompRef, DSRead } from 'types/documentServices';

export function resolveCompRefWithVariant(dsRead: DSRead, compRef: CompRef) {
  return compRef.type === 'MOBILE'
    ? dsRead.components.variants.getPointer(compRef, [
        dsRead.variants.mobile.get(),
      ])
    : compRef;
}
